import * as React from 'react'

import { observer } from 'mobx-react'

import { SitePermitStatus } from '~/client/graph'
import OptionsItem from '~/client/src/shared/components/OptionsList/pieces/OptionsItem'
import OptionsListPanel from '~/client/src/shared/components/OptionsList/pieces/OptionsListPanel'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { IStatusOptionsParams } from './workflowStatusOptions'
import WorkflowStatusRows from './WorkflowStatusRows'

interface IProps extends IStatusOptionsParams {
  setStatusAndStep(status: SitePermitStatus, stepId: string): void

  onClose?(): void
}

function WorkflowStatusPanel({
  setStatusAndStep,
  onClose,
  ...params
}: IProps): JSX.Element {
  return (
    <OptionsListPanel
      title={Localization.translator.updateStatus}
      onClose={onClose}
    >
      <WorkflowStatusRows
        {...params}
        setStatusAndStep={setStatusAndStep}
        renderRow={row => (
          <OptionsItem
            key={row.key}
            label={row.label}
            selected={row.isSelected}
            onClick={row.onSelect}
          />
        )}
      />
    </OptionsListPanel>
  )
}

export default observer(WorkflowStatusPanel)
